<po-page-edit
  p-title="Pré-cadastro Fornecedor"
  [p-breadcrumb]="breadcrumb"
>
  <form #formPrincipal="ngForm">
    <po-widget class="po-sm-12 po-md-12 po-lg-12"
      p-title="Informações do Fornecedor"
    >
      <po-select class="po-md-12 po-xl-2"
        name="CURGENTE"
        p-label="Urgente?"
        [(ngModel)]="urgente"
        [p-options]="[
          {value: 'N', label: 'Não'},
          {value: 'S', label: 'Sim'},
        ]"
        [p-required]="true"
        [p-show-required]="true"
        [p-disabled]="bloqueiaDadosSolicitante"
      ></po-select>
      <po-combo class="po-md-12 po-xl-2"
        name="CA2TIPO"
        p-label="Tipo de Pessoa"
        [(ngModel)]="preFornecedor.CA2TIPO"
        [p-options]="[
          {value: 'F', label: 'Física'},
          {value: 'J', label: 'Jurídica'},
          {value: 'X', label: 'Estrangeiro'},
        ]"
        [p-required]="true"
        [p-show-required]="true"
        [p-disabled]="bloqueiaDadosSolicitante"
        (p-change)="alteraTipo($event)"
      ></po-combo>
      <po-input class="po-md-12 po-xl-4"
        name="CA2CGC"
        [p-label]="preFornecedor.CA2TIPO==='X'?'Customer ID NUMBER':preFornecedor.CA2TIPO==='F'?'CPF':preFornecedor.CA2TIPO==='J'?'CNPJ':'CPF/CNPJ'"
        [(ngModel)]="preFornecedor.CA2CGC"
        [p-required]="preFornecedor.CA2TIPO !== 'X'"
        [p-disabled]="bloqueiaDadosSolicitante"
        [p-mask]="preFornecedor.CA2TIPO==='F'?'999.999.999-99':'AA.AAA.AAA/AAAA-99'" 
        p-clean="true"
        (p-change)="validarCIP()"
      ></po-input>
      <po-input class="po-md-12 po-xl-4"
        name="CA2PFISICA"
        p-label="RG"
        [(ngModel)]="preFornecedor.CA2PFISICA"
        [p-required]="preFornecedor.CA2TIPO==='F'?true:false"
        [p-disabled]="bloqueiaDadosSolicitante"
        p-clean="true"
        [p-maxlength]="15"
        [p-minlength]="0"
      ></po-input>
      <po-input class="po-md-12 po-xl-6"
        name="CA2NOME"
        p-label="Razão Social"
        [(ngModel)]="preFornecedor.CA2NOME"
        [p-required]="true"
        [p-show-required]="true"
        [p-disabled]="bloqueiaDadosSolicitante"
        p-clean="true"
        [p-maxlength]="40"
        [p-minlength]="5"
        [pattern]="patternPadraoTotvs"
        p-error-pattern="Tamanho entre 5 40 caracteres ou Caracteres inválidos"
        (p-change-model)="preFornecedor.CA2NOME = preFornecedor.CA2NOME.toUpperCase();"
      ></po-input>
      <po-input class="po-md-12 po-xl-6"
        name="CA2NREDUZ"
        p-label="Nome Fantasia"
        [(ngModel)]="preFornecedor.CA2NREDUZ"
        [p-required]="true"
        [p-show-required]="true"
        [p-disabled]="bloqueiaDadosSolicitante"
        p-clean="true"
        [p-maxlength]="20"
        [p-minlength]="5"
        [pattern]="patternPadraoTotvs"
        p-error-pattern="Tamanho entre 5 e 20 caracteres ou Caracteres inválidos"
        (p-change-model)="preFornecedor.CA2NREDUZ = preFornecedor.CA2NREDUZ.toUpperCase();"
      ></po-input>
      <po-divider class="po-md-12 po-mt-2"></po-divider>
      @if (preFornecedor.CA2TIPO !== 'X') {
        <po-input class="po-md-12 po-xl-4"
          name="CA2CEP"
          p-label="CEP"
          [(ngModel)]="preFornecedor.CA2CEP"
          p-mask="99.999-999"
          [p-required]="true"
          [p-show-required]="true"
          [p-disabled]="bloqueiaDadosSolicitante"
          (p-change)="alteraCep($event)"
          (p-blur)="alteraCep($event)"
          (keyup.enter)="alteraCep($event)"
          [p-maxlength]="10"
          [p-minlength]="10"
        ></po-input>
      }
      <po-combo class="po-md-12 po-xl-4"
        name="CA2CODPAIS"
        p-label="País"
        [(ngModel)]="preFornecedor.CA2CODPAIS"
        p-icon="po-icon-search"
        p-field-label="label"
        p-field-value="value"
        p-filter-service="{{urlApiProtheus}}/wsrlocalizacao/pais"
        [p-filter-params]="{combobox:'S'}"
        p-disabled-init-filter="false"
        p-infinite-scroll="true"
        [p-required]="true"
        [p-show-required]="true"
        [p-disabled]="bloqueiaDadosSolicitante || preFornecedor.CA2TIPO"
        [p-clean]="true"
      ></po-combo>
      <po-combo class="po-md-12 po-xl-4"
        #poSelectEst
        name="CA2EST"
        p-label="Estado"
        [(ngModel)]="preFornecedor.CA2EST"
        [p-options]="listaEstado"
        [p-required]="true"
        [p-show-required]="true"
        [p-clean]="true"
        (p-change)="municipioIBGEService.estado =  $event"
      ></po-combo>
      <po-input class="po-md-12 po-xl-3"
        name="CA2END"
        p-label="Endereço"
        [(ngModel)]="preFornecedor.CA2END"
        [p-required]="true"
        [p-show-required]="true"
        [p-disabled]="bloqueiaDadosSolicitante"
        p-clean="true"
        [p-maxlength]="40"
        [p-minlength]="5"
        [pattern]="patternPadraoTotvs"
        p-error-pattern="Tamanho entre 5 e 60 caracteres ou Caracteres inválidos"
        (p-change-model)="preFornecedor.CA2END = preFornecedor.CA2END.toUpperCase();"
      ></po-input>
      <po-input class="po-md-12 po-xl-4"
        name="CA2COMPLEM"
        p-label="Complemento"
        [(ngModel)]="preFornecedor.CA2COMPLEM"
        [p-disabled]="bloqueiaDadosSolicitante"
        p-clean="true"
        [p-maxlength]="50"
        [p-minlength]="0"
        [pattern]="patternPadraoTotvs"
        p-error-pattern="Caracteres inválidos"
      ></po-input>
      <po-input class="po-md-12 po-xl-2"
        name="CA2BAIRRO"
        p-label="Bairro"
        [(ngModel)]="preFornecedor.CA2BAIRRO"
        [p-required]="true"
        [p-show-required]="true"
        [p-disabled]="bloqueiaDadosSolicitante"
        p-clean="true"
        [p-maxlength]="20"
        [p-minlength]="5"
        [pattern]="patternPadraoTotvs"
        p-error-pattern="Tamanho entre 5 e 20 caracteres ou Caracteres inválidos"
        (p-change-model)="preFornecedor.CA2BAIRRO = preFornecedor.CA2BAIRRO.toUpperCase();"
      ></po-input>
      @if ( preFornecedor.CA2TIPO === 'X' ) {
        <po-input class="po-sm-6 po-md-3 po-lg-3"
          name="CA2MUN"
          p-label="Município"
          [(ngModel)]="preFornecedor.CA2MUN"
          [p-required]="true"
        [p-show-required]="true"
          [p-disabled]="bloqueiaDadosSolicitante"
          p-clean="true"
          [p-maxlength]="60"
          [p-minlength]="5"
          [pattern]="patternPadraoTotvs"
          p-error-pattern="Tamanho entre 5 e 60 caracteres ou Caracteres inválidos"
          (p-change-model)="preFornecedor.CA2MUN = preFornecedor.CA2MUN.toUpperCase();"
        ></po-input>
      } @else {
        <po-lookup class="po-md-12 po-xl-3"
          name="CA2COD_MUN"
          p-label="Município IBGE"
          [(ngModel)]="preFornecedor.CA2COD_MUN"
          p-field-label="CCC2MUN"
          p-field-value="CCC2CODMUN"
          [p-columns]="columnsMunicipioIBGEFilters"
          [p-field-format]="fieldFormaterMunicipioIBGEFilters"
          [p-filter-service]="municipioIBGEService"
          [p-advanced-filters]="advancedMunicipioIBGEFilters"
          [p-literals]="{ modalTitle: 'MunicipioIBGE' }"
          (p-selected)="municipioIBGESelecionado($event)"
          [p-disabled]="bloqueiaDadosSolicitante || !municipioIBGEService.estado"
          [p-required]="true"
          [p-show-required]="true"
        ></po-lookup>
      }
      <po-divider class="po-md-12 po-mt-2"></po-divider>
      <po-input class="po-md-12 po-xl-1"
        name="CA2CX_POST"
        p-label="Caixa Postal"
        [(ngModel)]="preFornecedor.CA2CX_POST"
        [p-disabled]="bloqueiaDadosSolicitante"
        p-clean="true"
        [p-maxlength]="5"
        [p-minlength]="0"
      ></po-input>
      <po-input class="po-md-12 po-xl-1"
        name="CA2DDD"
        p-label="DDD"
        [(ngModel)]="preFornecedor.CA2DDD"
        [p-disabled]="bloqueiaDadosSolicitante"
        p-mask="999"
        p-clean="true"
      ></po-input>
      <po-input class="po-md-12 po-xl-3"
        name="CA2TEL"
        [p-label]="preFornecedor.CA2TIPO!=='X'?'Fone':'Fone Export'"
        [(ngModel)]="preFornecedor.CA2TEL"
        [p-disabled]="bloqueiaDadosSolicitante"
        [p-maxlength]="15"
        [p-minlength]="8"
        p-clean="true"
      ></po-input>
      <po-input class="po-md-12 po-xl-3"
        name="CA2FAX"
        [p-label]="preFornecedor.CA2TIPO!=='X'?'Fax':'Fax Export'"
        [(ngModel)]="preFornecedor.CA2FAX"
        [p-disabled]="bloqueiaDadosSolicitante"
        [p-maxlength]="15"
        [p-minlength]="0"
        p-clean="true"
      ></po-input>
      <po-input class="po-md-12 po-xl-4"
        name="CA2CONTATO"
        p-label="Contato"
        [(ngModel)]="preFornecedor.CA2CONTATO"
        [p-disabled]="bloqueiaDadosSolicitante"
        [p-maxlength]="15"
        [p-minlength]="0"
        [pattern]="patternPadraoTotvs"
        p-error-pattern="Caracteres inválidos"
        p-clean="true"
        (p-change-model)="preFornecedor.CA2CONTATO = preFornecedor.CA2CONTATO.toUpperCase();"
      ></po-input>
      <po-divider class="po-md-12 po-mt-2"></po-divider>
      <po-input class="po-md-12 po-xl-6"
        name="CA2INSCR"
        p-label="Inscrição Estadual"
        [(ngModel)]="preFornecedor.CA2INSCR"
        [p-disabled]="bloqueiaDadosSolicitante || preFornecedor.CA2TIPO==='X'"
        [p-maxlength]="18"
        [p-minlength]="0"
        p-clean="true"
        [p-show-required]="preFornecedor.CA2TIPO!=='F'"
        [p-required]="preFornecedor.CA2TIPO!=='F'"
      ></po-input>
      @if ( preFornecedor.CA2TIPO !== 'X' ) {
        <po-input class="po-md-12 po-xl-6"
          name="CA2INSCRM"
          p-label="Inscrição Municipal"
          [(ngModel)]="preFornecedor.CA2INSCRM"
          [p-disabled]="bloqueiaDadosSolicitante"
          [p-maxlength]="18"
          [p-minlength]="0"
          p-clean="true"
        ></po-input>
      }
      <po-divider class="po-md-12 po-mt-2"></po-divider>
      <po-combo class="po-md-12 po-xl-3"
        name="CA2BANCO"
        p-label="Banco"
        [(ngModel)]="preFornecedor.CA2BANCO"
        p-icon="po-icon-search"
        [p-options]="listaBanco"
        p-filter-mode="contains"
        [p-disabled]="bloqueiaDadosSolicitante"
        p-clean="true"
        (p-change)="bancoSelecionado()"
      ></po-combo>
      <po-input class="po-md-12 po-xl-1"
        name="CA2AGENCIA"
        [(ngModel)]="preFornecedor.CA2AGENCIA"
        p-label="Agência (4 dígitos)"
        [p-disabled]="bloqueiaDadosSolicitante"
        [p-minlength]="1"
        [p-maxlength]="4"
        [p-required]="preFornecedor.CA2BANCO!==''"
        [p-disabled]="!preFornecedor.CA2BANCO"
        (p-blur)="(preFornecedor.CA2AGENCIA = preFornecedor.CA2AGENCIA.padStart(4,'0'))"
      ></po-input>
      <po-input class="po-md-12 po-lg-8"
        name="CA2NUMCON"
        [(ngModel)]="preFornecedor.CA2NUMCON"
        p-label="Conta Corrente (numero + digito / sem hífen)"
        [p-disabled]="bloqueiaDadosSolicitante"
        [p-minlength]="1"
        [p-maxlength]="10"
        p-mask="9999999999"
        [p-required]="preFornecedor.CA2BANCO!==''"
        [p-disabled]="!preFornecedor.CA2BANCO"
      ></po-input>
      <po-input class="po-md-12 po-xl-6"
      p-icon="po-icon-mail"
      name="CA2EMAIL"
      [(ngModel)]="preFornecedor.CA2EMAIL"
      p-label="Email"
      [p-required]="true"
      [p-show-required]="true"
      p-placeholder="example@domain.com"
      [p-disabled]="bloqueiaDadosSolicitante"
      [p-maxlength]="100"
      [p-minlength]="0"
      ></po-input>
      <po-url class="po-md-12 po-xl-6"
      name="CA2HPAGE"
      [(ngModel)]="preFornecedor.CA2HPAGE"
      p-label="Home Page"
      p-placeholder="www.domain.com"
      [p-disabled]="bloqueiaDadosSolicitante"
      [p-maxlength]="30"
      [p-minlength]="0"
      ></po-url>
      <po-divider class="po-md-12 po-mt-2"></po-divider>
      <po-combo class="po-md-12 po-xl-6"
        name="CA2NATUREZ"
        p-label="Natureza"
        [(ngModel)]="preFornecedor.CA2NATUREZ"
        p-icon="po-icon-search"
        p-field-label="label"
        p-field-value="value"
        p-filter-service="{{urlApiProtheus}}/wsrnatureza"
        [p-filter-params]="{combobox:'S'}"
        p-disabled-init-filter="false"
        p-infinite-scroll="true"
        [p-required]="true"
        [p-show-required]="true"
        [p-disabled]="bloqueiaDadosSolicitante"
        p-clean="true"
      ></po-combo>
      <po-select class="po-md-12 po-xl-6"
        name="CA2CONTA"
        p-label="Conta"
        [(ngModel)]="preFornecedor.CA2CONTA"
        p-icon="po-icon-search"
        [p-options]="listaContaContabil"
        [p-required]="true"
        [p-show-required]="true"
        [p-disabled]="bloqueiaDadosSolicitante"
        p-clean="true"
      ></po-select>
      <po-combo class="po-md-12 po-xl-6"
        name="CA2COND"
        p-label="Condição de Pagamento Padrão"
        [(ngModel)]="preFornecedor.CA2COND"
        p-icon="po-icon-search"
        p-field-label="label"
        p-field-value="value"
        p-filter-service="{{urlApiProtheus}}/wsrcondpag"
        [p-filter-params]="{combobox:'S'}"
        p-disabled-init-filter="false"
        p-infinite-scroll="true"
        [p-required]="true"
        [p-show-required]="true"
        [p-disabled]="bloqueiaDadosSolicitante"
        p-clean="true"
      ></po-combo>
      <po-combo class="po-md-12 po-xl-6"
        name="CA2GRPTRIB"
        p-label="Grupo Tributário"
        [(ngModel)]="preFornecedor.CA2GRPTRIB"
        p-icon="po-icon-search"
        p-field-label="label"
        p-field-value="value"
        p-filter-service="{{urlApiProtheus}}/wsrbase/zprcombo/GRUPOFOR"
        [p-filter-params]="{combobox:'S'}"
        p-disabled-init-filter="false"
        p-infinite-scroll="true"
        [p-required]="true"
        [p-show-required]="true"
        [p-disabled]="bloqueiaDadosSolicitante"
        p-clean="true"
      ></po-combo>
    </po-widget>
    @if (liberaAvancarProcesso) {
      <po-widget class="po-md-12" p-title="Observações">
        <po-textarea class="po-md-12"
          name="OBSERVACAO"
          [(ngModel)]="historico"
          [p-required]="true"
          [p-show-required]="true"
          p-rows="4"
          p-minlength="10"
        ></po-textarea>

        @if (preFornecedor.NCODIGO) {
          <po-button class="po-md-12 po-xl-6"
            p-label="{{ [' ','2'].includes(processoCadastro.CSTATUS) ? 'Cancelar' : 'Recusar' }} Processo"
            p-danger="true"
            p-size="large"
            p-kind="primary"
            (p-click)="cancelarRecusarTela()"
          ></po-button>
          <po-button class="po-md-12 po-xl-6"
            p-label="Avançar Processo"
            p-size="large"
            p-kind="primary"
            (p-click)="confirmarTela()"
          ></po-button>
        } @else {
          <po-button class="po-md-12"
            p-label="Salvar Cadastro"
            (p-click)="confirmarTela()"
            p-size="large"
            p-kind="primary"
          ></po-button>
        }
      </po-widget>
    }
  </form>
  <po-widget p-title="Histórico do Processo" class="po-md-12">
    <po-table class="po-sm-12 po-md-12 po-lg-12"
      [p-items]="tabelaHistorico"
      [p-columns]="tabelaHistoricoColunas"
      [p-hide-columns-manager]="true"
      p-container="true"
      p-spacing="small"
      [p-height]="300"
    ></po-table>
  </po-widget>
</po-page-edit>
